import instance from "../../utils/axios";

// ✅ Fetch All or by ID
export const fetchCarecells = async (_id) => {
  const formData = new URLSearchParams();
  if (_id) formData.append("_id", _id);
  const response = await instance.post("/churches/carecells/read", formData);
  return response.data;
};

// ✅ Save Carecell
export const saveCarecell = async (carecellInputs) => {
  const formData = new URLSearchParams();
  Object.entries(carecellInputs || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );
  const response = await instance.post("/churches/carecells/save", formData);
  return response.data;
};

// ✅ Update Carecell
export const updateCarecell = async (carecellInputs) => {
  const formData = new URLSearchParams();
  Object.entries(carecellInputs || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );
  const response = await instance.post("/churches/carecells/update", formData);
  return response.data;
};

// ✅ Delete Carecell
export const deleteCarecell = async ({ _id, carecellObjId }) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);
  formData.append("carecellObjId", carecellObjId);

  const response = await instance.post("/churches/carecells/delete", formData);
  return response.data;
};


// ✅ Fetch by ID
export const fetchCarecellById = async (_id) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);
  const response = await instance.post("/churches/carecells/read", formData);
  return response.data;
};
